export default "__VITE_ASSET__7322209b__"